import React from 'react';
import Modal from 'react-bootstrap/Modal';
import MonitoringPortalsList from 'components/molecules/monitoring_portals_list';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { PanelState } from 'store/modules/panel_store/types';
import { openSupportChat } from 'services/support_chat';

interface MonitoringPortalsListModalProps {
  modalListOpened: boolean;
  setModalListOpened: React.Dispatch<React.SetStateAction<boolean>>;
}

const MonitoringPortalsListModal = (props: MonitoringPortalsListModalProps) => {
  const { modalListOpened, setModalListOpened } = props;
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  return (
    <Modal size="lg" show={modalListOpened}>
      <div className="modal-header dark-bg">
        <h5 className="modal-title text-light" id="staticBackdropLabel">
          Conheça os portais disponíveis do Monitorar Chat
        </h5>
        <button
          type="button"
          className="close text-light"
          data-dismiss="modal"
          aria-label="Close"
          onClick={() => setModalListOpened(false)}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <p>
          {' '}
          {!panel.partner_id
            ? 'Agora você também pode monitorar os pregões dos seguintes portais:'
            : 'Assinando a plataforma ConLicitação você pode monitorar pregões dos seguintes portais:'}
        </p>
        <MonitoringPortalsList imgSize="32px" cardSize="col-md-3" />
        {!panel.partner_id && (
          <p>
            Acesse seus <a href="/boletim_web/public/boletins">Boletins de Licitações</a> ou o{' '}
            <a href="/banco_de_dados">Encontrar Licitações</a> para começar a monitorar pregões
            desses portais.
          </p>
        )}

        {panel.partner_id && (
          <div className="text-center my-2">
            <button
              className="btn btn btn-lg btn-primary ml-1 tour-help-btn text-white"
              type="button"
              onClick={() => openSupportChat()}
            >
              Experimente grátis por 15 dias
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default MonitoringPortalsListModal;
